<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      
    </div>
  </li>
</template>

<script>

  export default {
    name: 'Profile',
    methods: {
      logout: function() {
            this.$router.replace('/auth/login');
            localStorage.removeItem('User')
          }
    },
    computed: {
      logged: () => {
        return JSON.parse(localStorage.getItem("logged"));
      }
    }
  };
</script>
